import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from '../../../../../core/shared/mvs-page/page.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';

/**
 * Routed frame of „Meine Anträge" in the CONSULTANT shell — {@code cw/request/mine} there.
 *
 * <p>A pure frame, exactly like {@code tm/page/consultant-page/page/tickets-page}: the whole
 * surface is {@code <cw-my-requests>}, so the list has ONE implementation regardless of how it is
 * reached.</p>
 *
 * <p>TM-1000002000 („nur Vorgänge"): that surface is now ONE table, „Laufende Anträge" — the
 * consultant's Vorgänge without the closed phases. The former tabs, the Antrag list „Antragsentwürfe"
 * and its draft badge are gone. The page title stays „Meine Anträge", matching the menu entry.</p>
 *
 * <h3>Same address, different page per shell — the established pattern of this shell</h3>
 * The Alpha shell keeps its single Antrag list ({@code CwRequestMinePage}) on
 * {@code cw/request/mine}; the consultant shell binds the same address to this page, which shows
 * Vorgänge. Two precedents: {@code cr/customers/:id} and {@code cm/contract/:id} are both bound to a
 * consultant-specific page in {@code shell-consultant}. Which other Antrag addresses of the
 * consultant shell lead here is decided by its route table, not by this frame.
 *
 * @ticket TM-1000002000
 */
@Component({
    selector: 'cw-my-requests-page',
    templateUrl: './cw-my-requests.page.html',
    standalone: false
})
export class CwMyRequestsPage extends PageComponent implements OnInit {

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService) {
        super(route, coreService);
    }

    override ngOnInit(): void {
        this.defaultLabel = 'Meine Anträge';
        super.ngOnInit();

        this.refreshComponent();
    }

    refreshComponent(): void {
        this.initialized = true;
    }

}
